import { useCallback, useRef, useState } from "react";
import ArchivesList from "./ArchivesList";
import ArchiveBuilder from "./ArchiveBuilder";
import Page from "@hpo/client/utilities/Page";
import PageHeader from "@hpo/client/utilities/PageHeader";
import Spacer from "@hpo/client/utilities/Spacer";
import Tabs, { Tab, TabsRef } from "@hpo/client/utilities/Tabs";
import { ArchivePrefill } from "@hpo/client/models/Archive";

export default function ArchiveNavigator() {
  const tabsRef = useRef<TabsRef>(null);

  const [edited, setEdited] = useState<ArchivePrefill | null>(null);

  const onPrefill = useCallback((params: ArchivePrefill) => {
    setEdited(params);
    if (!tabsRef.current) return;
    tabsRef.current.setCurrentTab("builder");
  }, []);

  const onBuilt = useCallback(() => {
    if (!tabsRef.current) return;
    tabsRef.current.setCurrentTab("list");
  }, []);

  return (
    <Page>
      <PageHeader
        title="Rapports"
        subtitle="Générez des rapports PDF reprenant les données de la plateforme"
      />
      <Spacer />
      <Tabs queryParam="tab" ref={tabsRef}>
        <Tab title="Rapports disponibles" id="list">
          <ArchivesList onEditParams={onPrefill} />
        </Tab>
        <Tab title="Produire un rapport" id="builder">
          <ArchiveBuilder
            prefill={edited}
            onPrefilled={() => setEdited(null)}
            onBuilt={onBuilt}
          />
        </Tab>
      </Tabs>
    </Page>
  );
}
